import { Job } from '@betterleap/client';

export const getJobCompanyName = (job: Job) => {
  return job.organization?.name || job.externalCompany || '';
};

export const isJobPromoted = (job: Job) => {
  const currentBudget = (job.promotedJob?.budgets ?? []).reduce(
    (acc, budget) => {
      return acc + budget.currentBudgetBalance;
    },
    0,
  );

  return (
    !!job.promotedJob?.id && !job.promotedJob.isPaused && currentBudget > 0
  );
};
